module.exports = __webpack_public_path__ + "static/media/pexels.731d3411.svg";